import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import AudienceGrid from '../components/services/AudienceGrid';
import BusinessValueSection from '../components/services/BusinessValueSection';
import FeatureGrid from '../components/services/FeatureGrid';
import ProblemSolution from '../components/services/ProblemSolution';
import RoadmapSection from '../components/services/RoadmapSection';
import ServiceCTA from '../components/services/ServiceCTA';
import ServiceHero from '../components/services/ServiceHero';
import ServiceMetrics from '../components/services/ServiceMetrics';
import { services } from '../data/services';

function ServicePage() {
  const { serviceSlug } = useParams();
  const service = services[serviceSlug];

  useEffect(() => {
    if (!service) {
      return;
    }

    document.title = service.seo.title;

    const metaDescription =
      document.querySelector('meta[name="description"]') || document.createElement('meta');
    metaDescription.setAttribute('name', 'description');
    metaDescription.setAttribute('content', service.seo.description);

    if (!metaDescription.parentNode) {
      document.head.appendChild(metaDescription);
    }
  }, [service]);

  if (!service) {
    return <Navigate replace to="/services/devxfactor" />;
  }

  return (
    <div className="service-page">
      <ServiceHero service={service} />
      <ServiceMetrics items={service.snapshot} />
      <ProblemSolution problem={service.problem} solution={service.solution} />
      <FeatureGrid
        capabilitySections={service.capabilitySections}
        features={service.features}
      />
      <AudienceGrid items={service.audience} />
      <BusinessValueSection
        factorStreetFit={service.factorStreetFit}
        items={service.investorValue}
      />
      <RoadmapSection items={service.roadmap} />
      <ServiceCTA cta={service.cta} />
    </div>
  );
}

export default ServicePage;
